import {Size} from "../../../base/data/size";

export class FormFileConfig {

  public size: Size | undefined = undefined;
  // e.g. 'image/png, image/jpeg'
  public accept: string | undefined = undefined;

  constructor(init?: Partial<FormFileConfig> | undefined) {
    Object.assign(this, init);
  }
}
